var React = require('react');
var { connect } = require('react-redux');
var { withTranslation } = require('react-i18next');
var { SHORT_MONTH_KEYS } = require('../../utils/allFarmViewFormatters');
var kmlManager = require('kmlManager');
var MarkersCSS = require('markersCSS');
var L = require('leaflet');
var { GestureHandling } = require('leaflet-gesture-handling');
require('leaflet.pm');
require('leaflet.pm/dist/leaflet.pm.css');
require('leaflet/dist/leaflet.css');
require('leaflet-gesture-handling/dist/leaflet-gesture-handling.css');
var locationManager = require('locationManager');
var dayjs = require('../../utils/dayjsConfig');
var markerCluster = require('leaflet.markercluster');
require('leaflet.markercluster.placementstrategies');
var { sensorsMap } = require('sensorsManager');
var {
  buildSelectedFieldMarkerIconHtml,
  buildUnselectedFieldMarkerIconHtml,
} = require('./mapMarkerIconHelpers');
var { computeBoundsKey, shouldFlyToBounds } = require('./mapBoundsHelpers');
var { createGoogleTileLayer } = require('../../utils/googleMapTiles');
var { getEqualDistanceValues } = require('@managers/ndviManager');
var { createCoordsBoundsFromBbox } = require('@managers/geoManager');
var ToggleSwitch = require('ToggleSwitch');
const ReactDOM = require('react-dom/client');

const MAP_LINK_URL = 'http://www.google.com/maps/place/';

// NDVI timeline list dimensions
const NDVI_LIST_BASE_WIDTH = 144; // Base width for NDVI list items
const SCROLLBAR_WIDTH = 10; // Reserved space for Windows scrollbar (no effect on Mac overlay scrollbars)
const NDVI_LIST_TOTAL_WIDTH = NDVI_LIST_BASE_WIDTH + SCROLLBAR_WIDTH; // 154px total

// Polygon border styling
const NDVI_SELECTED_BORDER_COLOR = '#4563c7'; // --color-primary-idel
const NDVI_DEFAULT_BORDER_COLOR = '#919db4'; // --color-grey-71

// Zoom-based border weight: linear scaling per zoom level
const getSelectedBorderWeight = (zoom) =>
  Math.min(16, Math.max(3, (zoom - 12) * 2));
const getDefaultBorderWeight = (zoom) =>
  Math.min(4, Math.max(1, (zoom - 12) * 0.75));

const getBorderWeights = (zoom) => ({
  selected: getSelectedBorderWeight(zoom),
  default: getDefaultBorderWeight(zoom),
});

class CustomMap extends React.Component {
  constructor(props) {
    super(props);

    this.refresh = this.refresh.bind(this);
    this.resetMap = this.resetMap.bind(this);
    this.invalidate = this.invalidate.bind(this);

    this.onLayersChange = this.onLayersChange.bind(this);
    this.paintPolygons = this.paintPolygons.bind(this);
    this.addNDVIMenu = this.addNDVIMenu.bind(this);
    this.paintMarkers = this.paintMarkers.bind(this);
    this.clearLayers = this.clearLayers.bind(this);
    this.updatePolygonFillOpacity = this.updatePolygonFillOpacity.bind(this);
    this.updateBorderWeightsForZoom =
      this.updateBorderWeightsForZoom.bind(this);
    this.getArea = this.getArea.bind(this);
    this.onPolygonClick = this.onPolygonClick.bind(this);
    this.onMarkerClick = this.onMarkerClick.bind(this);
    this.loadedKMLPolygons = this.loadedKMLPolygons.bind(this);
    this.addLayersMenu = this.addLayersMenu.bind(this);
    this.addSearchBarMenu = this.addSearchBarMenu.bind(this);
    this.onLayerSelection = this.onLayerSelection.bind(this);
    this.changeNDVIToggle = this.changeNDVIToggle.bind(this);
    this.getNdviToggleState = this.getNdviToggleState.bind(this);

    this.refreshNDVILayer = this.refreshNDVILayer.bind(this);
    this.refreshLayers = this.refreshLayers.bind(this);

    // this.plusButtonClicked = this.plusButtonClicked.bind(this);
    this.mymap = null;
    this.marker = null;
    this.DEFUALT_ZOOM_LEVEL = 15;
    // this.plus_button = undefined;
    this.filePickerButton = undefined;

    this.state = {
      polygons: undefined,
      markers: undefined,
      selectedFieldOnly:
        props.selectedFieldOnly !== undefined ? props.selectedFieldOnly : true,
      shouldPresentFarmingUnitNdvi: true,
      ndviToggle: props.defaultNdviOff ? true : false,
      shouldDisplayNDVI: true,
    };

    this.mapBounds = [];

    this.customLayers = {};

    this.selectedMarker = null;
    this.shouldReopenMarkerPopup = false;
    this.lastFlownBoundsTarget = null;
    this.currentFarmingUnitId = null;
    this.previousLayer = 'Satelite'; // Track the layer before NDVI was activated (default, will be updated after map loads)
  }

  // Track which farming unit the map is currently displaying. Including the
  // farming unit id in the bounds key (see paintPolygons) makes the viewport
  // re-fit when the user switches farming units, even when no individual field
  // is selected on either unit (N-22).
  setCurrentFarmingUnitId(farmingUnitId) {
    this.currentFarmingUnitId = farmingUnitId ?? null;
  }

  // Helper function to detect which base layer is currently active
  detectActiveLayer() {
    if (!this.mymap || !this.customLayers) {
      return 'Satelite'; // default
    }
    // Check which base layer is currently active
    // Add null checks for each layer before calling hasLayer()
    if (
      this.customLayers['streets'] &&
      this.mymap.hasLayer(this.customLayers['streets'])
    ) {
      return 'Streets';
    } else if (
      this.customLayers['topography'] &&
      this.mymap.hasLayer(this.customLayers['topography'])
    ) {
      return 'Topography';
    } else if (
      this.customLayers['satelite'] &&
      this.mymap.hasLayer(this.customLayers['satelite'])
    ) {
      return 'Satelite';
    }
    return 'Satelite'; // default fallback
  }

  // Call this function when adding the map on a modal
  // onComplete callback is called after the map has finished updating
  invalidate(
    polygons,
    markers,
    ndviurls,
    shouldShowSearchBar,
    shouldPresentFarmingUnitNdvi,
    onComplete,
  ) {
    this.mymap.invalidateSize();

    if (polygons != null && markers != null) {
      this.refresh(
        polygons,
        markers,
        ndviurls,
        shouldShowSearchBar,
        shouldPresentFarmingUnitNdvi,
        onComplete,
      );
    } else if (onComplete) {
      onComplete();
    }
  }

  refresh(
    polygons,
    markers,
    ndviurls,
    shouldShowSearchBar,
    shouldPresentFarmingUnitNdvi,
    onComplete,
  ) {
    // Store current NDVI state before refresh
    const wasNdviOn = !this.state.ndviToggle;

    this.addSearchBarMenu(shouldShowSearchBar);
    this.paintPolygons(polygons);
    this.paintMarkers(markers);
    // Reset to undefined so refreshNDVILayer falls back to the latest
    // available timestamp (Math.max) — keeps the view from getting stuck
    // on an outdated image after newer NDVI data arrives.
    this.selectedNDVILayer = undefined;
    this.addNDVIMenu(ndviurls);
    let shouldDisplayNDVI =
      this.props.shouldDisplayNDVI && ndviurls && ndviurls.length > 0;
    this.addLayersMenu();
    this.setState(
      (prevState) => ({
        ...prevState,
        shouldDisplayNDVI: shouldDisplayNDVI,
        // When controlled via prop, always use the prop value; otherwise preserve current state or default
        selectedFieldOnly:
          this.props.selectedFieldOnly !== undefined
            ? this.props.selectedFieldOnly
            : (prevState.selectedFieldOnly ?? !shouldPresentFarmingUnitNdvi),
        shouldPresentFarmingUnitNdvi: shouldPresentFarmingUnitNdvi,
      }),
      () => {
        // Only auto-restore NDVI if no onComplete callback is provided.
        // When onComplete is provided, the caller manages NDVI state
        // (e.g., farm view controls NDVI via its own toggle).
        if (!onComplete && wasNdviOn && ndviurls && ndviurls.length > 0) {
          // Switch to NDVI layer (latest image, since selectedNDVILayer is undefined)
          this.onLayerSelection({ target: { id: 'ndvi' } });
        }
        // Call onComplete callback after map is fully updated
        if (onComplete) {
          onComplete();
        }
      },
    );
  }

  changeNDVIToggle() {
    let isToggleOff = !this.state.ndviToggle;
    this.setState((prevState) => ({
      ...prevState,
      ndviToggle: isToggleOff,
    }));

    mixpanel.track('NDVI Layer Button Clicked', {
      State: isToggleOff ? 'off' : 'on',
    });

    if (isToggleOff) {
      // Restore the previous layer (before NDVI was activated)
      this.onLayerSelection({ target: { id: this.previousLayer } });
    } else {
      // Store current layer before switching to NDVI
      var currentActiveLayer = this.detectActiveLayer();
      this.previousLayer = currentActiveLayer;
      this.onLayerSelection({ target: { id: 'ndvi' } });
    }
  }

  getNdviToggleState() {
    return this.state.ndviToggle;
  }

  getSelectedFieldOnlyState() {
    return this.state.selectedFieldOnly;
  }

  resetMap() {
    var that = this;
    this.paintPolygons({});
    this.paintMarkers({});

    locationManager
      .get_user_location()
      .then(function (res) {
        if (that.DEFUALT_ZOOM_LEVEL === that.mymap.getZoom()) {
          that.mymap.setView(
            new L.LatLng(res.latitude, res.longitude),
            this.DEFUALT_ZOOM_LEVEL,
          );
        }
      })
      .catch(function (err) {
        console.log(err);
      });
  }

  refreshLayers(currentLayer) {
    let newLayer = undefined;

    // Keep ndviToggle in sync with the actually-active layer for BOTH
    // directions. Previously it was only reset when leaving NDVI, so
    // activating NDVI via the layers menu left ndviToggle stale (still "off").
    // A later paintPolygons reads !this.state.ndviToggle, took the non-NDVI
    // branch, and drew a border-colored fill over the NDVI imagery (hiding it)
    // in both field and farm view.
    const isNdviLayer = currentLayer === 'ndvi';
    this.setState((prevState) => ({
      ...prevState,
      ndviToggle: !isNdviLayer,
    }));

    if (this.NDVIRecords && !isNdviLayer) {
      this.mymap.removeControl(this.NDVIRecords);
    }
    if (this.NDVIColorBar) {
      this.mymap.removeControl(this.NDVIColorBar);
    }
    Object.keys(this.customLayers).forEach((key) => {
      if (key.includes('ndvi') && currentLayer !== 'ndvi') {
        this.mymap.removeLayer(this.customLayers[key]);
      }
    });

    if (currentLayer === 'Satelite') {
      newLayer = this.customLayers['satelite'];
    } else if (currentLayer === 'Topography') {
      newLayer = this.customLayers['topography'];
    } else if (currentLayer === 'Streets') {
      newLayer = this.customLayers['streets'];
    } else if (currentLayer === 'ndvi') {
      this.refreshNDVILayer();
      if (this.NDVIRecords) {
        this.mymap.addControl(this.NDVIRecords);
      }
      if (this.NDVIColorBar) {
        this.mymap.addControl(this.NDVIColorBar);
      }
    }

    if (newLayer) {
      this.mymap.removeLayer(this.customLayers['topography']);
      this.mymap.removeLayer(this.customLayers['streets']);
      this.mymap.removeLayer(this.customLayers['satelite']);

      if (newLayer) {
        this.mymap.addLayer(newLayer);
      }
    }

    const isNdviActive = currentLayer === 'ndvi';
    this.updatePolygonFillOpacity(isNdviActive);
  }

  updatePolygonFillOpacity(isNdviActive) {
    if (!this.mymap) return;
    const weights = getBorderWeights(this.mymap.getZoom());
    try {
      this.mymap.eachLayer((layer) => {
        if (layer instanceof L.Polygon) {
          const meta = layer._polygonMeta;
          const styleUpdate = {};

          if (isNdviActive) {
            // No fill on any polygon in NDVI mode — a fill (even the grey dim
            // on non-selected fields) overlaps and hides the NDVI imagery.
            styleUpdate.fillOpacity = 0;
          } else {
            styleUpdate.fillOpacity = 0.4;
            if (meta) {
              styleUpdate.fillColor = meta.fillColor;
            }
          }

          if (meta) {
            styleUpdate.color = isNdviActive
              ? meta.selected
                ? NDVI_SELECTED_BORDER_COLOR
                : NDVI_DEFAULT_BORDER_COLOR
              : meta.fillColor;
            styleUpdate.weight = meta.selected
              ? weights.selected
              : weights.default;
          }
          layer.setStyle(styleUpdate);
        }
      });
    } catch (error) {
      console.error('Error updating polygon fill opacity:', error);
    }
  }

  updateBorderWeightsForZoom() {
    if (!this.mymap) return;
    const weights = getBorderWeights(this.mymap.getZoom());
    try {
      this.mymap.eachLayer((layer) => {
        if (layer instanceof L.Polygon && layer._polygonMeta) {
          const weight = layer._polygonMeta.selected
            ? weights.selected
            : weights.default;
          layer.setStyle({ weight });
        }
      });
    } catch (error) {
      console.error('Error updating border weights for zoom:', error);
    }
  }

  onLayerSelection(evnt) {
    if (evnt.target.id !== '') {
      var selectedLayer = evnt.target.id;
      // Update previousLayer when switching to a non-NDVI layer
      // (so we remember the last base layer before NDVI)
      if (selectedLayer !== 'ndvi' && selectedLayer !== '') {
        this.previousLayer = selectedLayer;
      }
      this.props.onLayerSelection(selectedLayer);
      this.refreshLayers(selectedLayer);
    }
  }

  addSearchBarMenu(shouldDisplaySearchBar) {
    var that = this;

    if (shouldDisplaySearchBar) {
      if (this.searchBar) {
        this.mymap.removeControl(this.searchBar);
      }

      var searchBar = L.Control.extend({
        options: {
          position: 'bottomleft',
        },

        onAdd: function (map) {
          var legend = L.DomUtil.create(
            'div',
            'map-legend',
            L.DomUtil.get('map'),
          );
          legend.innerHTML =
            "<div class='form-inline'><input class='form-control  text-size-12 mb-3' type='text' id='searchbox' name='searchbox' style='width:250px;height:28px' placeholder='latitude, longitude' value=''>" +
            "<button type='button' name='button' class='bg-super-light-grey text-grey45 ml-1 pt-1 pb-1 pl-1 pr-1 mb-3 rounded text-size-12'><img name='search_image' src='" +
            require('images/icons/edit_field/search.svg') +
            "'></button></div>";

          legend.onclick = function (e) {
            if (e.target.name === 'search_image') {
              e.stopPropagation();
              var searchText = document.getElementById('searchbox').value;
              if (searchText.includes(',')) {
                let longLatValues = searchText.split(',');
                if (longLatValues.length === 2) {
                  map.panTo(new L.LatLng(longLatValues[0], longLatValues[1]));
                  var myIcon = L.icon({
                    iconUrl: require('images/icons/map/selected_pin.svg'),
                    iconSize: [30, 90],
                    iconAnchor: [22, 94],
                    popupAnchor: [-3, -76],
                    shadowSize: [68, 95],
                    shadowAnchor: [22, 94],
                  });
                  L.marker([longLatValues[0], longLatValues[1]], {
                    icon: myIcon,
                    title: `${longLatValues[0]},${longLatValues[1]}`,
                  }).addTo(map);
                }
              }
            }
          };

          legend.ondblclick = function (e) {
            e.stopPropagation();
          };

          return legend;
        },
      });

      that.searchBar = new searchBar();
      that.mymap.addControl(that.searchBar);
    }
  }

  addLayersMenu() {
    var that = this;

    if (this.LayerButton) {
      this.mymap.removeControl(this.LayerButton);
    }

    // Zoom Extent
    var LayerButton = L.Control.extend({
      options: {
        position: 'bottomright',
      },

      onAdd: function (map) {
        var legend = L.DomUtil.create(
          'div',
          'map-legend',
          L.DomUtil.get('map'),
        );

        legend.innerHTML =
          "<div class='dropdown dropup'>" +
          "<div class='' data-toggle='dropdown' aria-haspopup='true' aria-expanded='false'>" +
          "<img src='" +
          require('images/icons/dashboard_states/layers_idle.svg') +
          "' onmouseover=\"this.src='" +
          require('images/icons/dashboard_states/layers_hover.svg') +
          '\'"' +
          ' onmouseout="this.src=\'' +
          require('images/icons/dashboard_states/layers_idle.svg') +
          '\'"' +
          ' onMouseDown="this.src=\'' +
          require('images/icons/dashboard_states/layers_press.svg') +
          "'\" class='img-fluid'/>" +
          '</div>' +
          "<div class='dropdown-menu dropdown-menu-right text-grey71  mr-2'>" +
          "<div class='dropdown-item text-grey71' style={'width':'10px'} id='Satelite' >" +
          (that.props.t?.('map_satellite') ?? 'Satellite') +
          '</div>' +
          "<div class='dropdown-item text-grey71' style={'width':'10px'} id='Topography'>" +
          (that.props.t?.('map_topography') ?? 'Topography') +
          '</div>' +
          "<div class='dropdown-item text-grey71' style={'width':'10px'} id='Streets'>" +
          (that.props.t?.('map_streets') ?? 'Streets') +
          '</div>' +
          '</div>' +
          '</div>';

        L.DomEvent.addListener(legend, 'click', (e) => {
          that.onLayerSelection(e);
        });

        legend.ondblclick = function (e) {
          e.stopPropagation();
        };

        return legend;
      },
    });

    that.LayerButton = new LayerButton();
    that.mymap.addControl(that.LayerButton);
  }
  componentDidUpdate(prevProps, prevState) {
    // Sync selectedFieldOnly when controlled via prop
    if (
      this.props.selectedFieldOnly !== undefined &&
      this.props.selectedFieldOnly !== prevProps.selectedFieldOnly
    ) {
      this.setState({ selectedFieldOnly: this.props.selectedFieldOnly }, () => {
        this.refreshNDVILayer();
      });
    }

    // Check if NDVI data just became available (wasn't there before, but is now)
    const hadNdviData = prevProps.selectedField?.historical_data?.['ndvi'];
    const hasNdviData = this.props.selectedField?.historical_data?.['ndvi'];
    const ndviDataJustArrived = !hadNdviData && hasNdviData;

    if (ndviDataJustArrived) {
      this.refreshNDVILayer();
      if (!this.state.ndviToggle) {
        this.onLayerSelection({ target: { id: 'ndvi' } });
      }
    }
    if (prevState.ndviToggle !== this.state.ndviToggle && this.CustomControl) {
      this.CustomControl.update(); // Trigger a re-render to update the ndvi toggle
    }
  }

  componentDidMount() {
    this.props.onRef(this);

    var that = this;

    // Base layers are ordinary tile layers fed by Google's Map Tiles API. The
    // old googlemutant layers fetched nothing: they scraped tiles out of a
    // second, hidden Google map, and Google draws nothing at all for a map
    // created inside a hidden container — so the edit-field modal's base layer
    // was always empty.
    this.customLayers['satelite'] = createGoogleTileLayer('hybrid');
    this.customLayers['streets'] = createGoogleTileLayer('roadmap');
    this.customLayers['topography'] = createGoogleTileLayer('terrain');

    this.mymap = L.map(this.props.mapId, {
      drawControl: true,
      center: [32.095998, 34.776344],
      zoom: this.DEFUALT_ZOOM_LEVEL,
      zoomControl: false,
      gestureHandling: L.Browser.mobile,
      layers: [this.customLayers['satelite']],
      // Google's terms require their attribution to show alongside the tiles.
      attributionControl: true,
      // Leaflet fades tiles in from opacity 0 via requestAnimationFrame. A map
      // built inside a hidden container (the edit-field modal) never runs those
      // frames, so its tiles download and then sit at opacity 0 forever — the
      // map looks blank, or shows a stray tile with the rest grey after a zoom.
      // Without the fade, tiles are painted at full opacity as soon as they load.
      fadeAnimation: false,
    });

    // Leaflet's own "Leaflet" prefix is not part of Google's attribution.
    this.mymap.attributionControl.setPrefix('');
    // this.mymap.zoomControl.setPosition('topright');

    this.mymap.scrollWheelZoom.disable();

    this.mymap.on('zoomend', () => {
      this.updateBorderWeightsForZoom();
    });

    this.resetMap();

    if (this.props.showEditToolBar) {
      // define toolbar options
      var options = {
        position: 'topleft', // toolbar position, options are 'topleft', 'topright', 'bottomleft', 'bottomright'
        useFontAwesome: false, // use fontawesome instead of geomanIcons (you need to include fontawesome yourself)
        drawMarker: false, // adds button to draw markers
        drawPolyline: false, // adds button to draw a polyline
        drawRectangle: false, // adds button to draw a rectangle
        drawPolygon: true, // adds button to draw a polygon
        drawCircle: false, // adds button to draw a cricle
        cutPolygon: false, // adds button to cut a hole in a polygon
        editMode: true, // adds button to toggle edit mode for all layers
        removalMode: true, // adds a button to remove layers
      };

      var optionspoly = {
        snappable: true,
        snapDistance: 10,

        templineStyle: {
          color: '#FFFFFF',
          weight: 4,
        },
        hintlineStyle: {
          color: '#FFFFFF',
          dashArray: [5, 5],
        },
        pathOptions: {
          color: '#FFFFFF',
          fillOpacity: 0.5,
        },
      };

      // enable drawing mode for shape - e.g. Poly, Line, etc
      this.mymap.pm.enableDraw('Poly', optionspoly);
      this.mymap.pm.disableDraw('Poly');

      // add leaflet.pm controls to the map
      this.mymap.pm.addControls(options);

      this.mymap.on('pm:drawend', this.onLayersChange);
      this.mymap.on('pm:remove', this.onLayersChange);
      this.mymap.on('pm:globaleditmodetoggled', this.onLayersChange);
    }

    // Stress menu
    var StressMenu = L.Control.extend({
      options: {
        position: 'bottomleft',
      },

      onAdd: function (map) {
        var legend = L.DomUtil.create(
          'div',
          'map-legend',
          L.DomUtil.get('map'),
        );

        legend.innerHTML =
          "<div >  \
        <div class='container'>\
          <div class='row text-white font-weight-bold'> \
            Stress Level \
          </div> \
          <div class='row'> \
            <div class='col-4 bg-red96 rounded-left'> &nbsp;</div><div class='col-4 bg-yellow100'>&nbsp; </div><div class='col-4 bg-green80 rounded-right text-white text-center'>Optimal</div> \
            </div> \
          </div> \
        </div>";

        legend.style.width = '300px';

        return legend;
      },
    });

    this.stressMenu = new StressMenu();

    // Zoom Out
    var ZoomOutButton = L.Control.extend({
      options: {
        position: 'topright',
      },

      onAdd: function (map) {
        var legend = L.DomUtil.create(
          'div',
          'map-legend',
          L.DomUtil.get('map'),
        );
        legend.innerHTML =
          "<div class='text-right btn btn-link  m-0 p-0'><img src='" +
          require('images/icons/dashboard_states/zoom_out_idle.svg') +
          "'" +
          ' onmouseover="this.src=\'' +
          require('images/icons/dashboard_states/zoom_out_hover.svg') +
          '\'"' +
          ' onmousedown="this.src=\'' +
          require('images/icons/dashboard_states/zoom_out_press.svg') +
          '\'"' +
          ' onmouseout="this.src=\'' +
          require('images/icons/dashboard_states/zoom_out_idle.svg') +
          '\'"' +
          " class='img-fluid'  alt='edit field'/></div>";

        legend.onclick = function () {
          that.mymap.setZoom(that.mymap.getZoom() - 1);
        };

        legend.ondblclick = function (e) {
          e.stopPropagation();
        };

        return legend;
      },
    });

    const CustomControl = L.Control.extend({
      options: {
        position: 'topleft',
      },

      initialize: function (onToggleClick, getState) {
        this.onToggleClick = onToggleClick; // Store the callback function
        this.getState = getState; // Store the function to fetch current ndvi toggle state
      },

      onAdd: function (map) {
        const container = L.DomUtil.create('div', 'custom-control-container');
        Object.assign(container.style, {
          height: '32px',
          paddingTop: '4px',
          paddingBottom: '4px',
          borderRadius: '8px',
          paddingRight: '12px',
          border: '1px solid #DCE0E8',
          backgroundColor: 'white',
          position: 'absolute',
        });
        container.id = 'ndvi';

        // Center the control
        map.on('resize', function () {
          const mapWidth = map.getContainer().clientWidth;
          const controlWidth = 97; // Width of the control in px
          const centerOffset = (mapWidth - controlWidth) / 2;
          container.style.left = `${centerOffset}px`;
        });
        map.fire('resize');

        L.DomEvent.disableClickPropagation(container);
        L.DomEvent.disableScrollPropagation(container);

        // Store the container for future updates
        this.reactRoot = ReactDOM.createRoot(container);

        // Render the React component
        this.renderReactComponent();

        return container;
      },

      renderReactComponent: function () {
        this.reactRoot.render(
          <ToggleSwitch
            initialValue={this.getState()}
            onToggleClick={this.onToggleClick} // Pass the function
            toggleTitle={'NDVI'}
            isLabelLeft={false}
            toggleSize={'small'}
            applyMarginBottom={false}
          />,
        );
      },

      update: function () {
        // Call this method to re-render the component
        this.renderReactComponent();
      },
    });

    // Zoom in
    var ZoomInButton = L.Control.extend({
      options: {
        position: 'topright',
      },

      onAdd: function (map) {
        var legend = L.DomUtil.create(
          'div',
          'map-legend',
          L.DomUtil.get('map'),
        );
        legend.innerHTML =
          "<div class='text-right btn btn-link  m-0 p-0'><img src='" +
          require('images/icons/dashboard_states/zoom_in_idle.svg') +
          "'" +
          ' onmouseover="this.src=\'' +
          require('images/icons/dashboard_states/zoom_in_hover.svg') +
          '\'"' +
          ' onmousedown="this.src=\'' +
          require('images/icons/dashboard_states/zoom_in_press.svg') +
          '\'"' +
          ' onmouseout="this.src=\'' +
          require('images/icons/dashboard_states/zoom_in_idle.svg') +
          '\'"' +
          " class='img-fluid'  alt='edit field'/></div>";

        legend.onclick = function () {
          that.mymap.setZoom(that.mymap.getZoom() + 1);
        };

        legend.ondblclick = function (e) {
          e.stopPropagation();
        };

        return legend;
      },
    });

    // Zoom Extent
    var ZoomExtentButton = L.Control.extend({
      options: {
        position: 'topright',
      },

      onAdd: function (map) {
        var legend = L.DomUtil.create(
          'div',
          'map-legend',
          L.DomUtil.get('map'),
        );
        legend.innerHTML =
          "<div class='text-right btn btn-link  m-0 p-0'><img src='" +
          require('images/icons/dashboard_states/zoom_extent_idle.svg') +
          "'" +
          ' onmouseover="this.src=\'' +
          require('images/icons/dashboard_states/zoom_extent_hover.svg') +
          '\'"' +
          ' onmousedown="this.src=\'' +
          require('images/icons/dashboard_states/zoom_extent_press.svg') +
          '\'"' +
          ' onmouseout="this.src=\'' +
          require('images/icons/dashboard_states/zoom_extent_idle.svg') +
          '\'"' +
          " class='img-fluid'  alt='edit field'/></div>";

        legend.onclick = function () {
          that.mymap.fitBounds(that.mapBounds, {
            padding: [50, 50],
            maxZoom: 18,
            animate: false,
          });
        };

        legend.ondblclick = function (e) {
          e.stopPropagation();
        };

        return legend;
      },
    });

    that.ZoomExtentButton = new ZoomExtentButton();
    that.mymap.addControl(that.ZoomExtentButton);
    that.ZoomInButton = new ZoomInButton();
    that.mymap.addControl(that.ZoomInButton);
    that.ZoomOutButton = new ZoomOutButton();
    that.mymap.addControl(that.ZoomOutButton);
    if (that.props.shouldDisplayNDVI) {
      that.CustomControl = new CustomControl(
        this.changeNDVIToggle,
        this.getNdviToggleState,
      );
      that.mymap.addControl(that.CustomControl);
    }

    // file picker button
    var FilePickerButton = L.Control.extend({
      options: {
        position: 'topleft',
      },

      onAdd: function (map) {
        var legend = L.DomUtil.create(
          'div',
          'leaflet-bar leaflet-control leaflet-control-custom text-center',
        );

        legend.style.backgroundColor = 'white';
        legend.style.width = '35px';
        legend.style.height = '31px';

        var folderelem = document.createElement('input');
        folderelem.setAttribute('type', 'file');
        folderelem.setAttribute('accept', '.kml, .kmz');
        folderelem.setAttribute('id', 'getFile');
        folderelem.setAttribute('style', 'display:none');
        folderelem.onchange = (e) => {
          kmlManager.onFileSelection(e, that.loadedKMLPolygons);
        };
        legend.appendChild(folderelem);

        var elem = document.createElement('img');
        elem.setAttribute('src', require('images/icons/folder.svg'));
        elem.setAttribute('height', '26');
        elem.setAttribute('width', '23');
        legend.appendChild(elem);

        legend.onclick = function () {
          document.getElementById('getFile').click();
        };

        legend.ondblclick = function (e) {
          e.stopPropagation();
        };

        return legend;
      },
    });

    that.filePickerButton = new FilePickerButton();

    // Initialize previousLayer with the actual active layer after map is loaded
    // Use setTimeout to ensure map layers are fully initialized
    setTimeout(function () {
      that.previousLayer = that.detectActiveLayer();
    }, 100);
  }

  componentWillUnmount() {
    this.props.onRef(undefined);
  }

  loadedKMLPolygons(polygons) {
    this.paintPolygons(polygons, true);
  }

  getArea() {
    var all_coordinates = [];
    this.mymap.eachLayer(function (layer) {
      if (layer instanceof L.Polyline) {
        var coordinates_formatted = layer
          .toGeoJSON()
          .geometry.coordinates[0].map((x) => {
            return { longitude: x[0], latitude: x[1] };
          });

        all_coordinates.push(coordinates_formatted);
      }
    });

    return all_coordinates;
  }

  clearMarkersLayers() {
    var that = this;
    if (this.mymap) {
      this.mymap.eachLayer(function (layer) {
        if (layer instanceof L.Marker) {
          that.mymap.removeLayer(layer);
        }

        if (layer instanceof L.FeatureGroup) {
          layer.clearLayers();
          that.mymap.removeLayer(layer);
        }
      });
    }
  }

  clearLayers() {
    var that = this;
    if (this.mymap) {
      this.mymap.eachLayer(function (layer) {
        if (layer instanceof L.Polyline || layer instanceof L.ImageOverlay) {
          that.mymap.removeLayer(layer);
        }
      });
    }
  }

  onLayersChange(e) {
    if (this.props.onAreaChanged) {
      var all_coordinates = this.getArea();
      this.props.onAreaChanged(all_coordinates);
    }
  }

  onPolygonClick(e) {
    this.selectedMarker = null;

    if (this.props.onPolygonClick) {
      this.props.onPolygonClick(e.sourceTarget.attribution);
    }
  }

  onMarkerClick(e) {
    var ids = e.sourceTarget.attribution;
    this.selectedMarker = ids.split('#')[1];
    this.shouldReopenMarkerPopup = true;

    if (this.props.onMarkerClick) {
      this.props.onMarkerClick(ids.split('#')[0]);
    }
  }

  paintMarkers(markers) {
    let selectedMarkerObj;

    // clear before painting new layers
    this.clearMarkersLayers();

    if (markers && Object.keys(markers).length > 0) {
      var markersGroup = window.L.markerClusterGroup({
        disableClusteringAtZoom: 16,
        elementsPlacementStrategy: 'original-locations',
        showCoverageOnHover: false,
        spiderLegPolylineOptions: { weight: 0, color: '#0000ffff', opacity: 0 },
        zoomToBoundsOnClick: true,

        iconCreateFunction: function (cluster) {
          return L.divIcon({
            className: 'marker-cluster',
            iconSize: [28, 28],
            html: '<div>' + cluster.getChildCount() + '</div>',
          });
        },
      });

      for (var current_container_index in markers) {
        for (var current_marker_index in markers[current_container_index]
          .markers) {
          var current_marker =
            markers[current_container_index].markers[current_marker_index];

          var iconSize = 24 + 4;
          var iconAnchor = iconSize / 2;
          var icon;

          var iconHtml;
          if (markers[current_container_index].selected) {
            iconHtml = buildSelectedFieldMarkerIconHtml({
              info: current_marker.info,
              color: current_marker.color,
              type: current_marker.type,
            });
          } else {
            iconHtml = buildUnselectedFieldMarkerIconHtml();
          }

          icon = L.divIcon({
            className: '',
            html: iconHtml,
            iconAnchor: [iconAnchor, iconAnchor],
            popupAnchor: [-1, -8],
          });
          var coordinateStr =
            parseFloat(current_marker.coordinates[0]).toFixed(6) +
            ', ' +
            parseFloat(current_marker.coordinates[1]).toFixed(6);
          var title =
            sensorsMap.get(current_marker.type) || current_marker.info || '';
          var popupcontent =
            '<table>' +
            '<tr>' +
            `<td class='map-marker-popup-header text-truncate'">${title}` +
            '</td><tr/>' +
            '<tr>' +
            "<td class='map-marker-popup-title'>Transmitter ID </td>" +
            `<td class='map-marker-popup-value'>#${current_marker.transmitter_id}` +
            '</td></tr>' +
            '<tr>' +
            "<td class='map-marker-popup-title'>Coordinates </td>" +
            "<td class='map-marker-popup-value'>" +
            `<a href="${MAP_LINK_URL}${current_marker.coordinates}"` +
            " style='color:#0000FF !important'; target='_blank'>" +
            coordinateStr +
            '</a></td></tr></table>';

          var marker = L.marker(current_marker.coordinates, {
            icon: icon,
          }).bindPopup(popupcontent, { direction: top, closeButton: false });

          marker.attribution =
            current_container_index + '#' + current_marker_index;

          marker.on('click', this.onMarkerClick);

          markersGroup.addLayer(marker);

          if (
            this.selectedMarker &&
            this.selectedMarker === current_marker_index
          ) {
            selectedMarkerObj = marker;
          }
        }
      }

      this.mymap.addLayer(markersGroup);

      markersGroup.on('clusterclick', function (a) {
        a.layer.zoomToBounds({ padding: [20, 20] });
      });

      if (selectedMarkerObj && this.shouldReopenMarkerPopup) {
        this.shouldReopenMarkerPopup = false;
        selectedMarkerObj.openPopup();
      }
    }
  }

  refreshColorBar(values) {
    const that = this;
    const initializeToggleStyle = (toggleSwitch, toggleHandle, toggleState) => {
      toggleSwitch.style.background =
        toggleState === 'right' ? '#4563C7' : '#EEF1F6';
      toggleHandle.style.left = toggleState === 'right' ? 'auto' : '0';
      toggleHandle.style.right = toggleState === 'right' ? '0' : 'auto';
    };
    var NDVIColorBar = L.Control.extend({
      options: {
        position: 'bottomright',
      },
      initialize: function (getSelectedFieldOnlyState) {
        this.getSelectedFieldOnlyState = getSelectedFieldOnlyState; // Store the function to fetch current ndvi toggle state
      },
      onAdd: () => {
        var baseColorBarStyle = {
          display: 'flex',
          'flex-direction': 'row',
          'align-items': 'center',
          height: '50px',
          width: '70%',
          background: '#FFFFFF',
          border: '1px solid #DCE0E8',
          'border-radius': '8px',
          'max-width': '660px',
        };
        var selectFieldOnlyStyle = that.state.shouldPresentFarmingUnitNdvi
          ? Object.assign({}, baseColorBarStyle, {
              gap: '6px',
              'padding-left': '6px',
            })
          : Object.assign({}, baseColorBarStyle, { 'padding-left': '8px' });
        const selectFieldOnlyToggle =
          that.state.shouldPresentFarmingUnitNdvi &&
          !that.props.hideSelectedFieldToggle
            ? `<div style="
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        height: 16px;
        width: 180px;
        gap: 6px;
      ">

        <span style="font-size: 14px; line-height: 14px; color: #4D5674; white-space: nowrap">Selected field only</span>

        <div id="toggle-switch" style="">
          <div id="toggle-handle" style="
            position: absolute;
            display: flex;
            justify-content: center;
            align-items: center;
            width: 12px;
            height: 12px;
            left: 14px;
            top: calc(50% - 12px/2);
            background: #FFFFFF;
            box-shadow: 0px 0px 3px rgba(64, 69, 79, 0.07), 0px 1px 1px rgba(64, 69, 79, 0.3);
            border-radius: 40px;
            cursor: pointer;
            margin-left: 2px;
            margin-right: 2px;
          "></div>
        </div>

      </div>`
            : `<div></div>`;
        const spectrumValues = values
          .map((value) => `<span>${value}</span>`)
          .join('');
        var legend = L.DomUtil.create(
          'div',
          'map-legend w-100',
          L.DomUtil.get('map'),
        );
        legend.innerHTML = `
<div style="width: 100%; background: transparent; display: flex; justify-content: center; margin-bottom: -40px;">
    <div style="width: 30px; flex-shrink: 0;"></div>
    <div style="${Object.entries(selectFieldOnlyStyle)
      .map(([key, value]) => `${key}: ${value};`)
      .join(' ')}">
${selectFieldOnlyToggle}
      <div style="
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        width: 100%;
        height: 34px;
        gap: 4px;
        padding-right: 8px;

      ">
        <div style="
          width: 100%;
          height: 16px;
          background: linear-gradient(to right, #E05223, #E68918, #ECC50C, #F2FF00, #98E600, #4FCB3D, #08B078, #0A6F92, #0B2FAB);
          border-radius: 3px;
        "></div>
        <div style="
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          width: 100%;
          height: 14px;
          font-weight: bold;
          font-size: 14px;
          color: #4D5674;
        ">
${spectrumValues}
        </div>
      </div>
    </div></div>
  `;

        // we don't want the double-click event to trigger any other event listeners that might be attached to parent elements.
        legend.ondblclick = (e) => {
          e.stopPropagation();
        };
        if (
          that.state.shouldPresentFarmingUnitNdvi &&
          !that.props.hideSelectedFieldToggle
        ) {
          const toggleHandle = legend.querySelector('#toggle-handle');
          const toggleSwitch = legend.querySelector('#toggle-switch');
          var handlePosition = this.getSelectedFieldOnlyState()
            ? 'right'
            : 'left'; // set initial handle position
          initializeToggleStyle(toggleSwitch, toggleHandle, handlePosition);

          toggleSwitch.addEventListener('click', function (e) {
            if (that.state.shouldPresentFarmingUnitNdvi) {
              const selectedFieldOnlyState = !that.getSelectedFieldOnlyState();
              mixpanel.track('NDVI Selected Field Toggle', {
                'Selected Field': selectedFieldOnlyState,
              });
              that.setState(
                { selectedFieldOnly: selectedFieldOnlyState },
                () => {
                  that.refreshNDVILayer();
                  that.updatePolygonFillOpacity(true);
                },
              );
              // Update UI immediately
              initializeToggleStyle(
                toggleSwitch,
                toggleHandle,
                selectedFieldOnlyState ? 'right' : 'left',
              );
            }
          });
        }

        return legend;
      },
    });
    this.NDVIColorBar = new NDVIColorBar(this.getSelectedFieldOnlyState);
    that.mymap.addControl(that.NDVIColorBar);
  }

  refreshNDVILayer() {
    const that = this;

    if (this.ndviUrls && this.ndviUrls.length > 0) {
      if (this.NDVIColorBar) {
        this.mymap.removeControl(this.NDVIColorBar);
      }

      var url = undefined;

      if (!this.selectedNDVILayer) {
        this.selectedNDVILayer = Math.max(...Object.keys(this.ndviUrls[0]));
      }

      let urls = this.ndviUrls[0][this.selectedNDVILayer];

      // Check if we're in field-level fallback mode
      let isFieldLevelFallback = false;
      if (urls) {
        Object.values(urls).forEach((tile) => {
          if (tile.isSelectedField && tile['farming_details']?.isFieldLevel) {
            isFieldLevelFallback = true;
          }
        });
      }

      let tileMin = 0;
      let tileMax = 1;
      if (urls) {
        Object.values(urls).forEach((tile) => {
          if (that.state.selectedFieldOnly && tile.isSelectedField) {
            tileMin = parseFloat(tile['min']);
            tileMax = parseFloat(tile['max']);
          }
          // Use farming_details for min/max calculation
          if (
            !that.state.selectedFieldOnly &&
            tile.isSelectedField &&
            tile['farming_details']
          ) {
            if (
              tile['farming_details'].isFieldLevel &&
              tile['farming_details'].tiles
            ) {
              // Field-level fallback: calculate min/max from all field tiles
              let allMins = [];
              let allMaxs = [];
              tile['farming_details'].tiles.forEach((fieldTile) => {
                if (fieldTile['min'] !== undefined) {
                  const minVal = parseFloat(fieldTile['min']);
                  if (!isNaN(minVal)) {
                    allMins.push(minVal);
                  }
                }
                if (fieldTile['max'] !== undefined) {
                  const maxVal = parseFloat(fieldTile['max']);
                  if (!isNaN(maxVal)) {
                    allMaxs.push(maxVal);
                  }
                }
              });
              if (allMins.length > 0 && allMaxs.length > 0) {
                tileMin = Math.min(...allMins);
                tileMax = Math.max(...allMaxs);
              }
            } else {
              // Normal farming unit level
              tileMin = parseFloat(tile['farming_details']['min']);
              tileMax = parseFloat(tile['farming_details']['max']);
            }
          }
        });
      }

      const values = getEqualDistanceValues(tileMin, tileMax);
      that.refreshColorBar(values);

      this.clearNdviLayers();

      for (let urlIndex in urls) {
        const tile = urls[urlIndex];
        const layerID = 'ndvi' + urlIndex.toString();

        if (this.state.selectedFieldOnly && tile['isSelectedField']) {
          this.addSelectedFieldNdviLayer(tile, layerID);
        } else if (!this.state.selectedFieldOnly && tile['farming_details']) {
          this.addFarmingUnitNdviLayer(tile, layerID);
        }
      }
    }
  }

  clearNdviLayers() {
    const that = this;
    Object.keys(this.customLayers).forEach(function (key) {
      if (key.startsWith('ndvi')) {
        that.mymap.removeLayer(that.customLayers[key]);
      }
    });
  }

  addSelectedFieldNdviLayer(tile, layerID) {
    const url = tile['image_path'];
    const bounds = createCoordsBoundsFromBbox(tile['bbox']);
    this.customLayers[layerID] = L.imageOverlay(url, bounds);
    this.mymap.addLayer(this.customLayers[layerID]);
  }

  addFarmingUnitNdviLayer(tile, layerID) {
    const farmingDetails = tile['farming_details'];

    if (farmingDetails.isFieldLevel) {
      this.addFieldLevelFallbackLayers(farmingDetails.tiles, layerID);
    } else {
      this.addFarmingUnitLevelLayer(farmingDetails, layerID);
    }
  }

  addFieldLevelFallbackLayers(tiles, baseLayerID) {
    tiles.forEach((fieldTile, tileIndex) => {
      const layerID = baseLayerID + '_field_' + tileIndex;
      const url = fieldTile['image_path'];
      const bounds = createCoordsBoundsFromBbox(fieldTile['bbox']);
      this.customLayers[layerID] = L.imageOverlay(url, bounds);
      this.mymap.addLayer(this.customLayers[layerID]);
    });
  }

  addFarmingUnitLevelLayer(farmingDetails, layerID) {
    const url = farmingDetails['image_path'];
    let bbox = farmingDetails['bbox'];

    // Handle case where bbox might be an array instead of a string
    if (Array.isArray(bbox)) {
      bbox = '[' + bbox.join(', ') + ']';
    } else if (typeof bbox !== 'string') {
      console.error('Invalid bbox format:', bbox);
      return;
    }

    const bounds = createCoordsBoundsFromBbox(bbox);
    this.customLayers[layerID] = L.imageOverlay(url, bounds);
    this.mymap.addLayer(this.customLayers[layerID]);
  }

  addNDVIMenu(ndviURLs) {
    if (ndviURLs) {
      this.ndviUrls = ndviURLs;
    }

    if (this.NDVIRecords) {
      this.mymap.removeControl(this.NDVIRecords);
    }

    if (this.NDVIColorBar) {
      this.mymap.removeControl(this.NDVIColorBar);
    }

    let that = this;

    if (this.ndviUrls && this.ndviUrls.length > 0) {
      var NDVIRecords = L.Control.extend({
        options: {
          position: 'topleft',
        },

        onAdd: function (map) {
          var legend = L.DomUtil.create(
            'div',
            'map-legend h-100',
            L.DomUtil.get('map'),
          );
          // Figma: NDVI menu - width: 154px, height: 360px, padding: 48px 0px 8px 8px
          legend.style.width = '146px';
          let legendHeight = '360px';
          let legendHeightImages = '320px'; // 360px - 32px header - 8px padding
          legend.style.height = legendHeight;
          legend.style.marginTop = '48px'; // Push down from top
          legend.style.borderRadius = '8px';
          legend.style.border = '1px solid #DCE0E8';
          legend.style.boxShadow = '0 0px 20px 0 rgba(0, 0, 0, 0.1)';
          legend.style.background = '#EEF1F6';
          legend.style.overflow = 'hidden';

          let str = '';
          let reversedUrls = Object.keys(that.ndviUrls[0]).reverse();

          for (let item in reversedUrls) {
            let isSelected =
              that.selectedNDVILayer &&
              reversedUrls[item] === that.selectedNDVILayer.toString();

            // Figma styles for NDVI item
            let itemStyle = isSelected
              ? 'box-sizing: border-box; display: flex; flex-direction: row; align-items: center; padding: 8px; gap: 8px; width: 100%; height: 32px; background: #EAEEFD; border: 1px solid #4563C7; border-radius: 4px; cursor: pointer;'
              : 'box-sizing: border-box; display: flex; flex-direction: row; align-items: center; padding: 8px; gap: 8px; width: 100%; height: 32px; background: #FFFFFF; border-bottom: 1px solid #DCE0E8; cursor: pointer;';

            let cloudIconColor = isSelected ? '#626E84' : '#919DB4';

            let cloudiness = '';
            let hasCloudiness = false;

            // calculate cloudiness
            for (let tile in that.ndviUrls[0][reversedUrls[item]]) {
              let currentTile = that.ndviUrls[0][reversedUrls[item]][tile];
              if (currentTile['isSelectedField']) {
                let cloudCover = Math.round(currentTile['cloud_cover'] * 100);
                if (Number.isFinite(cloudCover)) {
                  cloudiness = cloudCover;
                  hasCloudiness = true;
                }
              }
            }

            // Parse the date to get day and month separately
            let dateObj = dayjs.unix(reversedUrls[item]);
            let day = dateObj.format('D');
            let month =
              that.props.t?.(SHORT_MONTH_KEYS[dateObj.month()]) ??
              dateObj.format('MMM');

            str +=
              "<div style='" +
              itemStyle +
              "' " +
              "class='ndvi-timeline-item' " +
              "id='" +
              reversedUrls[item] +
              "' " +
              "data-selected='" +
              (isSelected ? 'true' : 'false') +
              "'>" +
              // Date wrap
              "<div style='display: flex; flex-direction: row; align-items: center; padding: 0px; gap: 2px; width: 56px; height: 16px;'>" +
              // Day
              "<span style='font-family: Source Sans Pro, sans-serif; font-weight: 400; font-size: 14px; line-height: 16px; text-align: right; color: #3B4259;'>" +
              day +
              '</span>' +
              // Month
              "<span style='font-family: Source Sans Pro, sans-serif; font-weight: 400; font-size: 14px; line-height: 16px; color: #3B4259;'>" +
              month +
              '</span>' +
              '</div>' +
              // Percentage wrap
              "<div style='display: flex; flex-direction: row; justify-content: flex-end; align-items: center; padding: 0px; gap: 4px; width: 56px; height: 16px;'>" +
              // Measurement (number + %) — empty until cloud_cover loads
              "<span style='font-family: Source Sans Pro, sans-serif; font-weight: 700; font-size: 14px; line-height: 16px; text-align: right; letter-spacing: 0.01em; color: #3B4259;'>" +
              (hasCloudiness ? cloudiness + '%' : '') +
              '</span>' +
              // Cloud icon (SVG)
              "<svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>" +
              "<path d='M13.5 10.5C14.3284 10.5 15 9.82843 15 9C15 8.17157 14.3284 7.5 13.5 7.5C13.5 5.29086 11.7091 3.5 9.5 3.5C7.79086 3.5 6.33333 4.60714 5.79167 6.16667C3.58333 6.16667 2 7.95238 2 9.83333C2 11.7143 3.58333 12.5 5.5 12.5H13.5C14.3284 12.5 15 11.8284 15 11V10.5H13.5Z' stroke='" +
              cloudIconColor +
              "' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/>" +
              '</svg>' +
              '</div>' +
              '</div>';
          }

          legend.innerHTML =
            "<div style='display: flex; flex-direction: column; height: 100%;'>" +
            // Header
            "<div style='box-sizing: border-box; display: flex; flex-direction: column; justify-content: center; align-items: center; padding: 8px 0px; width: 154px; height: 32px; background: #FFFFFF; border-bottom: 1px solid #DCE0E8;'>" +
            "<span style='font-family: Source Sans Pro, sans-serif; font-size: 14px; font-weight: 600; color: #3B4259;'>" +
            (that.props.t?.('ndvi_timeline') ?? 'NDVI timeline') +
            '</span>' +
            '</div>' +
            // List container with scroll
            "<div style='display: flex; flex-direction: row; flex: 1; overflow: hidden;'>" +
            // Items list - scrollbar-gutter reserves space for scrollbar on Windows, no effect on Mac overlay scrollbars
            "<div style='display: flex; flex-direction: column; align-items: flex-start; padding: 0px; width: " +
            NDVI_LIST_TOTAL_WIDTH +
            'px; max-height: ' +
            legendHeightImages +
            "; overflow-y: auto; scrollbar-gutter: stable;' class='ndvi-list-scroll'>" +
            str +
            '</div>' +
            '</div>' +
            '</div>';

          L.DomEvent.addListener(legend, 'click', (e) => {
            e.stopPropagation();
            e.preventDefault();

            let currentTarget = e.target;
            if (currentTarget.id === '') {
              while (currentTarget.id === '' && currentTarget.parentNode) {
                currentTarget = currentTarget.parentNode;
              }
            }

            if (
              currentTarget.id !== '' &&
              currentTarget.id !== 'dashboard' &&
              currentTarget.classList.contains('ndvi-timeline-item')
            ) {
              // Remove selected style from previous selection
              var selectedElement = document.getElementById(
                that.selectedNDVILayer,
              );
              if (selectedElement) {
                // Reset to normal item style
                selectedElement.style.border = 'none';
                selectedElement.style.borderBottom = '1px solid #DCE0E8';
                selectedElement.style.borderRadius = '0';
                selectedElement.style.backgroundColor = '#FFFFFF';
                // Update cloud icon color to grey
                var prevCloudIcon = selectedElement.querySelector('svg path');
                if (prevCloudIcon) {
                  prevCloudIcon.setAttribute('stroke', '#919DB4');
                }
              }

              // Add selected style to new selection (Figma specs)
              currentTarget.style.border = '1px solid #4563C7';
              currentTarget.style.borderRadius = '4px';
              currentTarget.style.backgroundColor = '#EAEEFD';
              // Update cloud icon color to darker grey
              var cloudIcon = currentTarget.querySelector('svg path');
              if (cloudIcon) {
                cloudIcon.setAttribute('stroke', '#626E84');
              }
              that.selectedNDVILayer = currentTarget.id;

              // Get source label for the selected NDVI layer
              let sourceLabel = '';
              for (let tile in that.ndviUrls[0][currentTarget.id]) {
                let currentTile = that.ndviUrls[0][currentTarget.id][tile];
                if (currentTile['isSelectedField']) {
                  sourceLabel = currentTile['source'] || '';
                  break;
                }
              }

              that.props.onNDVILayerSelection(currentTarget.id, sourceLabel);

              that.refreshNDVILayer();
            }
          });

          legend.ondblclick = function (e) {
            e.stopPropagation();
          };

          return legend;
        },
      });
      this.NDVIRecords = new NDVIRecords();
    }
  }

  paintPolygons(polygons, should_notify = false) {
    // clear before painting new layers
    this.clearLayers();

    if (polygons && Object.keys(polygons).length > 0) {
      var allPoints = [];
      var selectedFieldPoints = [];
      let selectedPolygons = [];

      const DEFAULT_POLYGON_COLOR = '#919db4'; // grey-71
      let boundsTarget = '__all__';

      for (var current_container_index in polygons) {
        const polygonData = polygons[current_container_index];
        if (!polygonData) continue; // Skip invalid entries
        if (polygonData['selected']) {
          boundsTarget = current_container_index;
        }
        var fill_color = polygonData['fill_color'];
        if (!fill_color || fill_color === 'transparent') {
          fill_color = DEFAULT_POLYGON_COLOR;
        }

        const isNdviLayerVisible = !this.state.ndviToggle;
        const weights = getBorderWeights(
          this.mymap ? this.mymap.getZoom() : 15,
        );
        const border_weight = polygonData['selected']
          ? weights.selected
          : weights.default;
        let border_color;
        if (isNdviLayerVisible) {
          border_color = polygonData['selected']
            ? NDVI_SELECTED_BORDER_COLOR
            : NDVI_DEFAULT_BORDER_COLOR;
        } else {
          border_color = fill_color;
        }

        for (var current_area_index in polygonData['areas']) {
          var latlngs = [];

          for (var current_coordinates_index in polygonData['areas'][
            current_area_index
          ]) {
            var current_coordinate =
              polygonData['areas'][current_area_index][
                current_coordinates_index
              ];

            latlngs.push([
              current_coordinate.latitude,
              current_coordinate.longitude,
            ]);
          }

          var fillOpacity;
          var fillColor = fill_color;
          if (isNdviLayerVisible) {
            // No fill on any polygon in NDVI mode — a fill (even the grey dim
            // on non-selected fields) overlaps and hides the NDVI imagery.
            fillOpacity = 0;
          } else {
            fillOpacity = 0.4;
          }

          var polygon = L.polygon(latlngs, {
            color: border_color,
            weight: border_weight,
            fillColor: fillColor,
            fillOpacity: fillOpacity,
            fill: true,
          }).bindTooltip(polygonData['title'], {
            className: 'map-polygon-tooltip',
            direction: 'bottom',
          });

          polygon._polygonMeta = {
            selected: !!polygonData['selected'],
            fillColor: fill_color,
          };

          polygon.attribution = current_container_index;

          polygon.on('click', this.onPolygonClick);

          allPoints.push(latlngs);

          if (latlngs.length > 0 && polygonData['selected']) {
            selectedFieldPoints.push(latlngs);
            selectedPolygons.push(polygon);
          } else {
            polygon.addTo(this.mymap);
          }
        }
      }

      // add selected polygons after all polygons so it will appear in the front
      selectedPolygons.map((a) => a.addTo(this.mymap));

      if (selectedFieldPoints && selectedFieldPoints.length > 0) {
        this.mapBounds = new L.LatLngBounds(selectedFieldPoints);
      } else {
        this.mapBounds = new L.LatLngBounds(allPoints);
      }

      const boundsKey = computeBoundsKey(
        this.currentFarmingUnitId,
        boundsTarget,
      );

      // Check if bounds are valid before fitting. The key includes the farming
      // unit id so switching units re-fits even when no field is selected.
      if (
        shouldFlyToBounds(
          this.mapBounds.isValid(),
          boundsKey,
          this.lastFlownBoundsTarget,
        )
      ) {
        this.lastFlownBoundsTarget = boundsKey;
        this.mymap.flyToBounds(this.mapBounds, {
          padding: [50, 50],
          maxZoom: 18,
          duration: 0.8,
        });
      }

      if (should_notify) {
        this.onLayersChange(undefined);
      }
    }
  }

  render() {
    if (this.filePickerButton) {
      this.props.shouldPresentFilePicker
        ? this.mymap.addControl(this.filePickerButton)
        : this.mymap.removeControl(this.filePickerButton);
    }

    if (this.stressMenu) {
      // this.props.shouldPresentStressMenu ? this.mymap.addControl(this.stressMenu) : this.mymap.removeControl(this.stressMenu);
    }

    if (document.getElementById('mapid')) {
      var map_claslist = document.getElementById('mapid').classList;
      if (this.props.message) {
        map_claslist.add('border-red', 'border', 'rounded');
      } else {
        map_claslist.remove('border-red', 'border', 'rounded');
      }
    }

    return (
      <div style={{ height: '100%' }}>
        <div
          id={this.props.mapId}
          style={{
            height: '100%',
            minHeight: this.props.map_height.toString() + 'px',
            borderRadius: '5px',
          }}
        ></div>
        <div className='text-red text-center'>
          <small>{this.props.message}</small>
        </div>
      </div>
    );
  }
}

const mapStateToProps = function (state) {
  return {};
};

const mapDispatchToProps = {};

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation()(CustomMap));
